export enum BarcodeTypeEnum {
  CODE128 = '128'
}

export enum MoneyTypeEnum {
  nal = 'Наличка',
  terminal = 'Терминал',
  card = 'Карта',
  bn = 'Безнал',
  A = 'А'
}

export enum BankStorageKindEnum {
  MANAGER_CASHBOX = 'MANAGER_CASHBOX',
  CENTRAL_SAFE = 'CENTRAL_SAFE',
  PAYMENT_CHANNEL = 'PAYMENT_CHANNEL'
}

export enum MoneyDayStatusEnum {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum MoneyDayCollectionStatusEnum {
  NOT_REQUIRED = 'NOT_REQUIRED',
  PENDING = 'PENDING',
  COLLECTED = 'COLLECTED'
}

export enum MoneyAdjustmentDirectionEnum {
  INFLOW = 'INFLOW',
  OUTFLOW = 'OUTFLOW'
}

export enum FuelTypeEnum {
  GASOLINE = 'Бензин',
  DIESEL = 'Дизель',
  ELECTRIC = 'Электричество',
  LPG = 'Пропан',
  METHAN = 'Метан',
  HYBRID = 'Гибрид'
}

export enum FiscalTypeEnum {
  test,
  fiscal
}
export enum AccessEnum {
  user,
  admin
}

export enum StatusEnum {
  proc = 'В обработке',
  collected = 'Собран',
  sent = 'Отправлен',
  done = 'Завершен',
  mark = 'Проценка',
  denial = 'Отказ'
}

export enum DocTypeEnum {
  import = 'Приход',
  export = 'Расход',
  order = 'Заказ',
  buy = 'Заказ поставщику'
}

export enum DeviceTypeEnum {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  LAPTOP = 'LAPTOP',
  DESKTOP = 'DESKTOP'
}

export enum BuyDocStatus {
  needsOrder = 'Нужно заказать',
  created = 'Создано',
  ordered = 'Заказано',
  partiallyDone = 'Частично прибыло',
  done = 'Прибыло',
  cancelled = 'Отменено'
}
